export default __webpack_public_path__ + "static/media/trail_off.3126236c.svg";